import React from 'react'
import PropTypes from 'prop-types'

import { AktivWrapper, Content, Heading, MapLink } from './style'
import { trackEvent } from '../../utils/analytics'

import PoiList from './components/PoiList'

import StaticMap from '../../ui/StaticMap'
import WidgetWrapper from '../WidgetWrapper'
import ReadMoreButton from './components/ReadMoreButton'

const AktivWidget = React.memo(({ address, links, location, pois }) => (
  <WidgetWrapper>
    <AktivWrapper>
      <header>
        <MapLink
          href={links.map}
          onClick={() => {
            trackEvent('clicked-map', 'click', links.map)
          }}
        >
          <StaticMap
            latitude={location.latitude}
            longitude={location.longitude}
            altText={address}
          />
        </MapLink>
      </header>
      <Content>
        <Heading>I nærheten</Heading>
        <PoiList pois={pois} />
        <ReadMoreButton link={links.main} />
      </Content>
    </AktivWrapper>
  </WidgetWrapper>
))

AktivWidget.propTypes = {
  address: PropTypes.string,
  links: PropTypes.shape({
    main: PropTypes.string.isRequired,
    map: PropTypes.string.isRequired,
  }),
  location: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
  pois: PropTypes.arrayOf(
    PropTypes.shape({
      distanceText: PropTypes.string,
      poiId: PropTypes.string,
      poiType: PropTypes.string,
      poiTypeId: PropTypes.number,
      travelType: PropTypes.string,
    }),
  ).isRequired,
}
AktivWidget.defaultProps = {}

export default AktivWidget
